import React from 'react';
import { Row, Col, Alert, Button, ButtonToolbar } from 'react-bootstrap';
import FieldGroup from './common/FieldGroup.jsx';
import DropDownInput from './common/DropDownInput.jsx';

export default class LabelOtherComponent extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  render() {

    let downloadLinkStyle = {
      display: this.props.otherLabel.get('outputFile') === '' ? 'none' : 'block'
    };

    let openPdf = () => {
      window.open(this.props.otherLabel.get('outputFile'));
    };

    let alertDiv = null;
    if (this.props.alertStyle || this.props.alertMessage) {
      alertDiv = (
        <Alert bsStyle={this.props.alertStyle} onDismiss={this.props.cleanAlert}>
          {this.props.alertMessage}
        </Alert>
      );
    }

    return (
      <div>
        <h4>標籤管理 - 頭套</h4>
        <Row style={{ marginLeft: -15, marginRight: -15 }}>
          <Col xs={12}>
            {alertDiv}
          </Col>
          <Col xs={12} sm={6} md={6}>
            <FieldGroup
              id="orderId"
              type="text"
              label="訂單編號"
              value={this.props.otherLabel.get('orderId')}
              placeholder=""
              required="true"
              onChange={(id, value) => {
                this.props.setValue(id, value);
              }}
              validation={this.props.otherLabelValidation.get('orderId')}
            />
          </Col>
          <Col xs={6} sm={2} md={2}>
            <FieldGroup
              id="serialNoFrom"
              type="number"
              label="序號 From"
              value={this.props.otherLabel.get('serialNoFrom')}
              placeholder=""
              onChange={(id, value) => {
                this.props.setValue(id, value);
              }}
              validation={this.props.otherLabelValidation.get('serialNoFrom')}
            />
          </Col>
          <Col xs={6} sm={2} md={2}>
            <FieldGroup
              id="serialNoTo"
              type="number"
              label="序號 To"
              value={this.props.otherLabel.get('serialNoTo')}
              placeholder=""
              onChange={(id, value) => {
                this.props.setValue(id, value);
              }}
              validation={this.props.otherLabelValidation.get('serialNoTo')}
            />
          </Col>
          <Col xs={6} sm={2} md={2}>
            <DropDownInput id="size"
              label="尺寸"
              options={[{ label: '不顯示', value: '' }, { label: 'M', value: 'M' }, { label: 'L', value: 'L' }]}
              onChange={(id, value, label) => {
                this.props.setValue(id, value);
              }}
              validation={this.props.otherLabelValidation.get('size')}
            />
          </Col>
          <Col xs={12} sm={3} md={3}>
            <FieldGroup
              id="manufactureDate"
              type="month"
              label="製造日期"
              value={this.props.otherLabel.get('manufactureDate')}
              placeholder=""
              required="true"
              onChange={(id, value) => {
                this.props.setValue(id, value);
              }}
              validation={this.props.otherLabelValidation.get('manufactureDate')}
            />
          </Col>
          <Col xs={12} sm={3} md={3}>
            <DropDownInput id="sizeType"
              label="類型"
              required="true"
              options={[{ label: '頭套(無尺寸)', value: 5 }, { label: '頭套(有尺寸)', value: 8 }]}
              onChange={(id, value, label) => {
                this.props.setValue(id, value);
                this.props.findOtherTemplateList({ sizeType: value });
              }}
              validation={this.props.otherLabelValidation.get('sizeType')}
            />
          </Col>
          <Col xs={12} sm={6} md={6}>
            <DropDownInput id="template"
              label="版型"
              required="true"
              options={this.props.templateList.map((value, key) => ({ label: value.get('model_display_name'), value: value.get('model_no') })).toJS()}
              onChange={(id, value, label) => {
                this.props.setValue(id, value);
              }}
              validation={this.props.otherLabelValidation.get('template')}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6} md={6}>
            <ButtonToolbar>
              <Button bsStyle="info" onClick={this.props.generateOtherLabel}>產生PDF檔</Button>
              <Button style={downloadLinkStyle} bsStyle="default" onClick={openPdf}>開啟PDF檔</Button>
            </ButtonToolbar>
          </Col>
        </Row>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/LabelOtherComponent.jsx